 /* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/self-closing-comp */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

import {
  Button,
  Menu,
  Box,
  ListItemText,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
  Paper,
  Chip,
  SwipeableDrawer,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import Icon from '../../components/icon/Icon';
import clear from '../../assets/icons/cancel.svg';
import { getVenderEventLists } from 'src/services/vendor/getVenderEventLists';
import { debounce } from 'lodash';
import searchIcon from '../../assets/icons/searchicon.svg';
import getEventsDetailsData from 'src/services/events/getEventsDetails';

const mapGroupName = (group) => {
  const labelMappings = {
    eventStatus: 'Event Status',
    eventCapacity: 'Event Capacity',
  };

  return labelMappings[group];
};

const mapLabels = (group, item) => {
  // Define your label mappings here
  const labelMappings = {
    eventCapacity: {
      belowFifty: 'below 50',
      fiftyToHundred: '50-100',
      aboveHundred: 'above 100',
    },
  };

  // Return the mapped label or use the original label
  return labelMappings[group]?.[item] || item;
};

export default function EventsFilter({
  selectedItems,
  setSelectedItems,
  packageTime,
  setPackageTime,
  setAnchorEl,
  anchorEl,
  selectedVendors,
  setSelectedVendors,
  page,
  page_size,
  eventFilterData,
  user,
  tabValue,
  selectedCities,
  setSelectedCities,
  citiesData,
}) {
  // const [anchorEl, setAnchorEl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [screenSize, setScreenSize] = useState('');
  const [vendorList, setVendorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const mode = localStorage.getItem('mode');
  const [search, setSearch] = useState('');
  const [tempSelectedVendor, setTempSelectedVendor] = useState([]);
  const [searchCity, setSearchCity] = useState('');

  useEffect(() => {
    const fetchVenderList = async () => {
      try {
        setLoading(true);
        const res = await getVenderEventLists('user');
        const filteredVendors = res?.payload?.filter((vendor) => vendor.mode === mode);
        setVendorList(filteredVendors);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchVenderList();
  }, []);

  const handleFilter = async () => {
    const filterData = await getEventsDetailsData(
      user,
      tabValue == 2 ? 0 : tabValue == 0 ? 2 : 1,
      '',
      page,
      page_size,
      eventFilterData
    );
  };

  const handleClearFilter = () => {
    setPackageTime({
      validFrom: '',
      validTill: '',
    });
    setSelectedItems({
      eventStatus: {
        Live: false,
        UpComing: false,
        Completed: false,
      },
      eventCapacity: {
        belowFifty: false,
        fiftyToHundred: false,
        aboveHundred: false,
      },
    });
    setSelectedVendors([]);
    setSelectedCities([]);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setTempSelectedVendor([]);
  };

  const handleFilterCloseWithAction = () => {
    setIsSubmitting(true);
    setSelectedVendors(tempSelectedVendor);
    handleFilter();

    handleClose();
    setIsSubmitting(false);
  };

  const handleCheckboxChange = (group, item) => () => {
    setSelectedItems((prev) => ({
      ...prev,
      [group]: {
        ...prev[group],
        [item]: !prev[group][item],
      },
    }));
  };

  const updatePackageTime = (key, value) => {
    setPackageTime((prev) => {
      const data = { ...prev };
      data[key] = value;
      return data;
    });
  };

  useEffect(() => {
    function handleResize() {
      // Get the current window width and determine the screen size
      const width = window.innerWidth;
      if (width < 600) {
        setScreenSize('sm');
      } else if (width >= 600 && width < 1280) {
        setScreenSize('md');
      } else {
        setScreenSize('lg');
      }
    }

    // Call handleResize initially and add event listener for window resize
    handleResize();
    window.addEventListener('resize', handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleDelete = (group, item) => {
    setSelectedItems((prev) => ({
      ...prev,
      [group]: {
        ...prev[group],
        [item]: !prev[group][item],
      },
    }));

    setIsSubmitting(true);
  };

  const handlePackageTimeDelete = () => {
    updatePackageTime('validFrom', '');
    updatePackageTime('validTill', '');
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (isSubmitting) {
      handleFilter();
      setIsSubmitting(false);
    }
  }, [selectedItems, packageTime, isSubmitting, handleFilter, selectedVendors]);

  useEffect(() => {}, [packageTime]);

  const itemsToRender = selectedItems ? Object.entries(selectedItems) : [];

  const handleSearchDebounce = debounce((searchText) => {
    setSearch(searchText.trimStart());
  }, 100);

  const handleSearch = (e) => {
    handleSearchDebounce(e.target.value);
  };

  const filterVendor = vendorList?.filter((item) =>
    item?.name?.toLowerCase().includes(search?.toLowerCase())
  );
  const debouncedCitySearch = debounce((v) => setSearchCity(v), 300);
  const filteredCities = citiesData?.filter((c) =>
    c?.label?.toLowerCase().includes(searchCity.toLowerCase())
  );

  useEffect(() => {
    setTempSelectedVendor(selectedVendors);
  }, [selectedVendors, anchorEl]);

  return (
    <Stack>
      <SwipeableDrawer
        anchor={screenSize === 'sm' ? 'bottom' : 'right'} // Assuming 'screenSize' is a string indicating screen size
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onOpen={() => {}}
        sx={{
          width: screenSize === 'sm' ? '100%' : screenSize === 'md' ? '50%' : '27%',
          height: screenSize === 'sm' ? '50%' : '100%', // Set height to '100%' for mobile width, 'auto' otherwise
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: screenSize === 'sm' ? '100%' : screenSize === 'md' ? '50%' : '27%',
            height: screenSize === 'sm' ? '60%' : '100%', // Set paper height to '100%' for mobile width, 'auto' otherwise
            borderRadius: 0,
          },
          position: 'relative',
        }}
      >
        <Box
          sx={{
            overflowY: 'auto',
            maxHeight: 'calc(100% - 60px)',
            '&::-webkit-scrollbar': { width: '1px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'blue' },
          }}
        >
          <Stack
            pa={2}
            mt={4}
            spacing={{ xs: 2, sm: 3 }}
            alignItems="center"
            direction="row"
            justifyContent="space-between"
            pt={{ xs: 3 }}
            sx={{ padding: '0 10px' }}
          >
            <Typography color="primary" variant="h4">
              Filters
            </Typography>

            <Icon icon={clear} onClick={handleClose} sx={{ cursor: 'pointer' }}></Icon>
          </Stack>

          {/* Selected Chips */}
          <Stack direction="row" flexWrap="wrap" gap={1} px={2}>
            {selectedCities?.map((id) => {
              const city = citiesData.find((c) => c.value === id);
              return (
                <Chip
                  color="primary"
                  key={id}
                  label={city?.label}
                  onDelete={() => setSelectedCities((prev) => prev.filter((x) => x !== id))}
                />
              );
            })}
          </Stack>

          {/* Cities Filter */}
          <Stack p={2}>
            <Paper sx={{ p: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search Cities"
                onChange={(e) => debouncedCitySearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} width={18} />
                    </InputAdornment>
                  ),
                }}
              />

              <Typography mt={1} fontWeight={600} color="primary">
                Cities
              </Typography>

              <Stack maxHeight={200} overflow="auto">
                {filteredCities?.map((city) => (
                  <FormControlLabel
                    key={city.value}
                    label={city.label}
                    control={
                      <Checkbox
                        checked={selectedCities.includes(city.value)}
                        onChange={(e) =>
                          e.target.checked
                            ? setSelectedCities((p) => [...p, city.value])
                            : setSelectedCities((p) => p.filter((x) => x !== city.value))
                        }
                      />
                    }
                  />
                ))}
              </Stack>
            </Paper>
          </Stack>

          <Stack
            maxWidth={{ xs: '100%', sm: '100%' }}
            flexWrap={{ xs: 'wrap', md: 'wrap' }}
            padding={{ lg: 1, xs: 2 }}
            sx={{
              overflowX: { xs: 'scroll', md: 'auto' },
              '&::-webkit-scrollbar': {
                width: '0px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'white ',
              },
            }}
            direction="row
"
            gap={1}
          >
            {itemsToRender.map(
              ([group, items]) =>
                items &&
                typeof items === 'object' &&
                Object.entries(items).map(
                  ([item, checked]) =>
                    checked && (
                      <Chip
                        color="primary"
                        sx={{
                          maxHeight: '24px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: 600,
                          fontFamily: 'Poppins',
                          backgroundColor: 'lightblue',
                        }}
                        key={item}
                        onDelete={() => handleDelete(group, item)}
                        label={mapLabels(group, item)}
                        variant="outlined"
                      />
                    )
                )
            )}

            {packageTime?.validFrom !== '' && packageTime?.validFrom !== 'Invalid Date' && (
              <Chip
                color="primary"
                sx={{
                  maxHeight: '24px',
                  borderRadius: '4px',
                  fontSize: '10px',
                  fontWeight: 600,
                  fontFamily: 'Poppins',
                  backgroundColor: 'lightblue',
                }}
                onDelete={handlePackageTimeDelete}
                label="Date & Time"
                variant="outlined"
              />
            )}
          </Stack>
          <Box
            sx={{
              maxWidth: '100%',

              '@media (min-width: 1024px)': {
                maxWidth: '600px',
              },
            }}
          >
            {/* {itemsToRender.map(([group, items]) => (
              <Box key={group} sx={{ p: 1 }}  >
                <Paper sx={{ border: '1px solid #E4E5E7' }}>
                  <Stack p={1}>
                    <ListItemText
                      primary={mapGroupName(group)}
                      primaryTypographyProps={{
                        style: {
                          fontFamily: 'Poppins',
                          fontWeight: 500,
                          margin:"10px 0",
                          fontSize: '20px',
                          color: '#7635dc',
                        },
                      }}
                    />
                    <Stack spacing={1}>
                      {items &&
                        typeof items === 'object' &&
                        Object.entries(items).map(([item, checked]) => (
                          <FormControlLabel
                            key={item}
                            control={
                              <Checkbox
                                checked={checked}
                                onChange={handleCheckboxChange(group, item)}
                              />
                            }
                            label={mapLabels(group, item)}
                          />
                        ))}
                    </Stack>
                  </Stack>
                </Paper>
              </Box>
            ))} */}

            <Stack p={1} mt={1}>
              <Paper sx={{ border: '1px solid #E4E5E7', p: 1 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Search Partners"
                  value={search}
                  onChange={handleSearch}
                  onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing
                  onKeyDown={(e) => e.stopPropagation()} // Ensure typing works
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box
                          component="img"
                          src={searchIcon}
                          alt="Search Icon"
                          sx={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 700,
                    fontSize: '16px',
                    marginTop: '5px',
                  }}
                  color="primary"
                  variant="h6"
                  mb={1}
                >
                  Partners
                </Typography>
                <Stack spacing={1} sx={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {filterVendor?.length === 0 && loading && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 100,
                      }}
                    >
                      <CircularProgress size={24} />
                    </Box>
                  )}

                  {filterVendor?.length > 0 ? (
                    filterVendor?.map((it, index) => {
                      if (!it.status) return null;
                      const isChecked = tempSelectedVendor.includes(it._id);
                      const handleVendorCheckboxChange = (e) => {
                        if (e.target.checked) {
                          setTempSelectedVendor((prev) => [...prev, it._id]);
                        } else {
                          setTempSelectedVendor((prev) => prev.filter((id) => id !== it._id));
                        }
                      };
                      return (
                        <FormControlLabel
                          key={it?._id}
                          control={
                            <Checkbox checked={isChecked} onChange={handleVendorCheckboxChange} />
                          }
                          label={it?.name}
                        />
                      );
                    })
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 100,
                      }}
                    >
                      <Typography>No Partners Found</Typography>
                    </Box>
                  )}
                </Stack>
              </Paper>
            </Stack>

            <Stack p={1} mt={1}>
              <Paper sx={{ border: '1px solid #E4E5E7', p: 1 }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontSize: '16px',
                  }}
                  color="primary"
                  variant="h6"
                  mb={1}
                >
                  Date Filter
                </Typography>
                <Stack direction="row" spacing={1}>
                  <DateTimePicker
                    required
                    closeOnSelect={false}
                    format="DD-MM-YYYY hh:mm A"
                    timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                    onChange={(newValue) => {
                      const formattedValue = dayjs(newValue).startOf('minute').format();
                      updatePackageTime('validFrom', formattedValue);
                    }}
                    value={packageTime?.validFrom ? dayjs(packageTime?.validFrom) : null}
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        // Targets the root of the input field
                        fontSize: '0.875rem', // Smaller font size
                        padding: '4px 8px', // Smaller padding
                      },
                      '& .MuiSvgIcon-root': {
                        // Targets the calendar/clock icon size
                        fontSize: '1rem',
                      },
                      '& .MuiFormControl-root': {
                        minHeight: '32px', // Adjust the overall height of the input
                      },
                    }}
                  />
                  <DateTimePicker
                    required
                    closeOnSelect={false}
                    format="DD-MM-YYYY hh:mm A"
                    timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                    onChange={(newValue) => {
                      const formattedValue = dayjs(newValue).startOf('minute').format();
                      updatePackageTime('validTill', formattedValue);
                    }}
                    minDateTime={packageTime?.validFrom ? dayjs(packageTime.validFrom) : null}
                    value={packageTime?.validTill ? dayjs(packageTime?.validTill) : null}
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        // Targets the root of the input field
                        fontSize: '0.875rem', // Smaller font size
                        padding: '4px 8px', // Smaller padding
                      },
                      '& .MuiSvgIcon-root': {
                        // Targets the calendar/clock icon size
                        fontSize: '1rem',
                      },
                      '& .MuiFormControl-root': {
                        minHeight: '32px', // Adjust the overall height of the input
                      },
                    }}
                  />
                </Stack>
              </Paper>
            </Stack>
          </Box>
          <Stack
            sx={{
              justifyContent: 'space-between',
              borderTop: '1px solid #E4E5E7',
              p: 1,
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: 1,
            }}
            direction="row"
          >
            <Stack direction="row" spacing={1}>
              <LoadingButton
                loading={isSubmitting}
                variant="contained"
                size="medium"
                onClick={handleFilterCloseWithAction}
              >
                Apply Filter
              </LoadingButton>
              <Button onClick={handleClearFilter} size="medium" sx={{ order: { xs: -1, lg: -1 } }}>
                Clear Filter
              </Button>
            </Stack>
            <Button
              sx={{ order: { xs: -1, lg: -1 } }}
              variant="outlined"
              onClick={handleClose}
              size="medium"
            >
              Cancel
            </Button>
          </Stack>
        </Box>
        {/* </Menu> */}
      </SwipeableDrawer>
      <Stack
        maxWidth={{ xs: '100%', sm: '100%' }}
        flexWrap={{ xs: 'wrap', md: 'wrap' }}
        // padding={{ lg: 1, xs: 2 }}
        sx={{
          // overflowX: { xs: "scroll", md: "auto" },
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            width: '0px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'white ',
          },
        }}
        direction="row
"
        gap={1}
      >
        {itemsToRender.map(
          ([group, items]) =>
            items &&
            typeof items === 'object' &&
            Object.entries(items).map(
              ([item, checked]) =>
                checked && (
                  <Chip
                    color="primary"
                    sx={{
                      maxHeight: '24px',
                      borderRadius: '4px',
                      fontSize: '10px',
                      fontWeight: 600,
                      fontFamily: 'Poppins',
                      backgroundColor: 'lightblue',
                    }}
                    key={item}
                    onDelete={() => handleDelete(group, item)}
                    label={mapLabels(group, item)}
                    variant="outlined"
                  />
                )
            )
        )}

        {packageTime?.validFrom !== '' && packageTime?.validFrom !== 'Invalid Date' && (
          <Chip
            color="primary"
            sx={{
              maxHeight: '24px',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: 600,
              fontFamily: 'Poppins',
              backgroundColor: 'lightblue',
            }}
            onDelete={handlePackageTimeDelete}
            label="Date & Time"
            variant="outlined"
          />
        )}
      </Stack>
    </Stack>
  );
}
